// Copyright (c) 2020 Deere & Company

import './index.scss';
import React, {
    Component,
    PropTypes
} from 'react';
import AdvanceReturnedPartInfoAccordion from './advance-returned-part-information/advance-returned-part-information-accordion';
import File from '@deere/cps-it.warranty-model-factory/lib/file';
import KeyValuePair from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';
import PartInfoPanel from '../../shared/components/Part-Info-Panel';
import ReturnedPartInfoAccordion from './returned-part-information/returned-part-information-accordion';
import RgaAdditionalDataInfo from '../../rga-search-results/state/rga-additional-data-info';
import RgaConsignmentDetails from '../../rga-search-results/state/rga-consignment-details';
import RgaDealerDetails from '../../rga-search-results/state/rga-dealer-details';
import RgaDetails from '../../rga-search-results/state/rga-details';
import RgaQuestionAnswer from '../../rga-search-results/state/rga-question-answer';
import Security from '@deere/cps-it.warranty-model-factory/lib/security';
import WarrantyLoadingIndicator from '../../../shared/components/warranty-loading-indicator';

class RgaRecalledPart extends Component {

    componentWillMount() {

        // this.props.actions.getRgaUnitsDropDown();
        // this.props.actions.getRgaStatusDropDown();
        // this.props.actions.getRgaRequestorTypeDropDown();
        // this.props.actions.getRgaAnalysisStatusDropDown();
       // this.props.actions.getRgaFiles(this.props.rgaDetails);

    }

    render() {

        return (
            <section className='rga-recalled-wip'>
                <WarrantyLoadingIndicator isLoading={this.props.busyCounter > 0}/>
                <main className='rga-recalled-main'>
                    <PartInfoPanel
                        actions={this.props.actions}
                        infoReqStatus={this.props.infoReqStatus}
                        partReqStatus={this.props.partReqStatus}
                        photoReqStatus={this.props.photoReqStatus}
                        queryParams={this.props.queryParams}
                        rgaDetails={this.props.rgaDetails}
                        security={this.props.security}
                    />
                    <div className='rga-advanced-search'>
                        <ReturnedPartInfoAccordion
                            actions={this.props.actions}
                            additionalDataFlag={this.props.additionalDataFlag}
                            additionalDataInfo={this.props.additionalDataInfo}
                            additionalDataTest={this.props.additionalDataTest}
                            additionalDataType={this.props.additionalDataType}
                            analysisStatus={this.props.analysisStatus}
                            busyCounter={this.props.busyCounter}
                            fileCollection={this.props.files}
                            partReqStatus={this.props.partReqStatus}
                            queryParams={this.props.queryParams}
                            rgaDetails={this.props.rgaDetails}
                            rgaQuestionAnswer={this.props.rgaQuestionAnswer}
                            rgaUnits={this.props.rgaUnits}
                            security={this.props.security}
                        />
                        <AdvanceReturnedPartInfoAccordion
                            actions={this.props.actions}
                            busyCounter={this.props.busyCounter}
                            queryParams={this.props.queryParams}
                            rgaConsignmentDetails={this.props.rgaConsignmentDetails}
                            rgaDealerDetails={this.props.rgaDealerDetails}
                            rgaDetails={this.props.rgaDetails}
                            security={this.props.security}
                        />
                    </div>
                </main>
            </section>

        );

    }

}

RgaRecalledPart.displayName = 'RgaRecalledPart';
RgaRecalledPart.propTypes = {
    actions: PropTypes.object.isRequired,
    additionalDataFlag: PropTypes.bool.isRequired,
    additionalDataInfo: PropTypes.instanceOf(RgaAdditionalDataInfo).isRequired,
    additionalDataTest: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)).isRequired,
    additionalDataType: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)).isRequired,
    analysisStatus: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)).isRequired,
    busyCounter: PropTypes.number.isRequired,
    currentStatus: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)).isRequired,
    files: PropTypes.arrayOf(PropTypes.instanceOf(File)).isRequired,
    genericStatus: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)).isRequired,
    infoReqStatus: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)).isRequired,
    partReqStatus: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)).isRequired,
    photoReqStatus: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)).isRequired,
    queryParams: PropTypes.object.isRequired,
    requesterType: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)).isRequired,
    rgaConsignmentDetails: PropTypes.instanceOf(RgaConsignmentDetails).isRequired,
    rgaDealerDetails: PropTypes.instanceOf(RgaDealerDetails).isRequired,
    rgaDetails: PropTypes.instanceOf(RgaDetails).isRequired,
    rgaQuestionAnswer: PropTypes.arrayOf(PropTypes.instanceOf(RgaQuestionAnswer)).isRequired,
    rgaUnits: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)).isRequired,
    searchQueryString: PropTypes.string.isRequired,
    security: PropTypes.instanceOf(Security).isRequired
};

export default RgaRecalledPart;



// WEBPACK FOOTER //
// ./src/rga/recalled-part-analysis/components/index.js